var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const GET_SET_ORDER_PAYMENTLINES = (orderId) => `/api/v2/order/${orderId}/paymentLines`;
const GET_SET_ORDER = 'api/v2/order';
const GET_SET_ORDER_CUSTOMERS_APP = 'api/v2/washdayapp/orders';
export const deletePaymentLineById = function (orderId, id) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.delete(`${GET_SET_ORDER_PAYMENTLINES(orderId)}/${id}`, config);
        }
        catch (error) {
            console.error('Error fetching deleteById:', error);
            throw error;
        }
    });
};
export const deleteOrderEvidence = function (orderId, evidenceId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.delete(`${GET_SET_ORDER}/${orderId}/evidence/${evidenceId}`, config);
        }
        catch (error) {
            console.error('Error fetching deleteOrderEvidence:', error);
            throw error;
        }
    });
};
export const cancelOrderByIdCustomersApp = function (id) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.delete(`${GET_SET_ORDER_CUSTOMERS_APP}/${id}`, config);
        }
        catch (error) {
            console.error('Error fetching cancelOrderByIdCustomersApp:', error);
            throw error;
        }
    });
};
